import { useMeetingControls } from '@alucio/video';
import React, { useEffect } from 'react';
import { DNABox, Iffy } from '@alucio/lux-ui';
const LeftSidePanel = React.memo((props) => {
    const { toggleSlides, toggleSlidesHandler } = useMeetingControls();
    const { isFullScreen, searchPanel, children, visibleSearch, setVisibleSearch } = props;
    useEffect(() => {
        if (visibleSearch && !toggleSlides) {
            toggleSlidesHandler();
        }
    }, [visibleSearch]);
    useEffect(() => {
        if (!toggleSlides) {
            setVisibleSearch(false);
        }
    }, [toggleSlides]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Iffy, { is: visibleSearch },
            React.createElement(DNABox, { fill: true }, searchPanel)),
        React.createElement(DNABox, { fill: true, style: { maxWidth: 350, display: (isFullScreen || toggleSlides) ? 'none' : 'flex' } }, children)));
});
export default LeftSidePanel;
//# sourceMappingURL=LeftSideBar.js.map